<template>
    <div>
        <div v-if="!hideMainState" :class="{'form__group':!onlyStates}">
            <label v-if="!onlyStates" class="form__label  form__label--block">{{ getTranslation('state') }}<span v-if="required" class="required">*</span></label>
            <v-select
                    :placeholder="placeholder || getTranslation('selectFromList')"
                    v-model="stateId"
                    label="name"
                    :reduce="state => state.id"
                    :options="states"
                    @search:blur="required && !stateId ? valid.stateId = false : valid.stateId = true"
                    :class="required ? { 'field--error': !valid.stateId } : {}"
                    ref="stateSelect"
                    :filter-by="option => option.fullText"
            />
            <div v-if="required && !valid.stateId" class="form__error">{{ getTranslation('requiredField') }}</div>
        </div>
        <div v-if="!onlyStates">
            <div class="form__group" v-for="(subdivision, idx) in subdivisions" v-bind:key="idx">
                <label class="form__label  form__label--block">{{ getTranslation('division') }}<span v-if="required" class="required">*</span></label>
                <v-select
                        v-if="!firstRequired && required"
                        :placeholder="getTranslation('selectFromList')"
                        v-model="subTree[idx]"
                        label="name"
                        :reduce="subdivision => subdivision.id"
                        :options="subdivision"
                        @input="subTreeChange(subTree[idx], idx+1)"
                        @search:blur="!subTree[idx] ? valid.lastStateId = false : valid.lastStateId = true"
                        :class="idx === subdivisions.length-1 ? { 'field--error': !valid.lastStateId } : {}"
                />
                <v-select
                        :placeholder="getTranslation('selectFromList')"
                        v-model="subTree[idx]"
                        label="name"
                        :reduce="subdivision => subdivision.id"
                        :options="subdivision"
                        @input="subTreeChange(subTree[idx], idx+1)"
                        v-else
                />
                <div v-if="!firstRequired && required && idx === subdivisions.length-1 && !valid.lastStateId" class="form__error">{{ getTranslation('requiredField') }}</div>
            </div>
        </div>
        <div class="form__group" v-if="lastState && ((onlyCentralDepartments && centralSubdivisionId===value) || !onlyCentralDepartments)">
            <label class="form__label  form__label--block">{{ departmentLabel || getTranslation('department') }}<span v-if="required" class="required">*</span></label>
            <v-select
                    v-if="required"
                    :placeholder="getTranslation('selectFromList')"
                    v-model="departmentId"
                    label="name"
                    :reduce="department => department.id"
                    :options="departments"
                    @search:blur="!departmentId ? valid.departmentId = false : valid.departmentId = true"
                    :class="{ 'field--error': !valid.departmentId }"
            />
            <v-select
                    v-else
                    :placeholder="getTranslation('selectFromList')"
                    v-model="departmentId"
                    label="name"
                    :reduce="department => department.id"
                    :options="departments"
            />
            <div v-if="required && !valid.departmentId" class="form__error">{{ getTranslation('requiredField') }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "StateSelect",
        props: {
            value: [Number, String],
            initialValue: Array,
            hideDepartment: Boolean,
            accessStates: Array,
            required: Boolean,
            checkValidation: Boolean,
            departmentLabel: String,
            getDepartments: Array,
            lastStates: Array,
            init: Boolean,
            firstRequired: Boolean,
            onlyStates: Boolean,
            placeholder: String,
            hideMainState: Boolean,
            onlyCentralDepartments: Boolean
        },
        data() {
            return {
                states: [],
                subdivisions: [],
                stateId: '',
                subTree: [],
                departmentId: '',
                departments: [],
                lastState: false,
                initializing: false,
                valid: {
                    stateId: true,
                    lastStateId: true,
                    departmentId: true
                },
                timer: null,
                admin: true,
                centralSubdivisionId: '',
            }
        },

        watch: {
            stateId( id ) {
                this.subdivisions = [];
                this.subTree = [];
                if ( !this.onlyStates ) {
                    if ( id ) {
                        this.fetchStates( id, 0 );
                        this.$emit( 'input', id );
                        this.lastState = false;
                        if ( !this.initializing ) this.$emit( 'change', id );
                    }
                    else {
                        this.$emit( 'input', id );
                        this.$emit( 'update:departmentId', id );
                        this.lastState = false;
                        if ( !this.initializing ) this.$emit( 'change', id );
                    }
                    this.$emit( 'update:lastStates', [] );
                    this.$emit( 'update:getDepartments', [] );
                }
                else this.$emit( 'input', id );
            },
            lastState( status ) {
                if ( !status ) this.departmentId = '';
            },
            departmentId( id ) {
                this.$emit( 'update:departmentId', id );
                if ( !this.initializing ) this.$emit( 'change' );
            },
            value( id ) {
                if ( id === 'reset' ) {
                    if ( !this.hideDepartment ) this.$emit( 'update:departmentId', '' );
                    this.stateId = '';
                }
            },
            initializing( status ) {
                if ( !status ) {
                    this.$emit( 'init', true );
                    this.$emit( 'update:init', true );
                }
            },
            subdivisionLength(val){
                if (val > 0 ){
                    if ( this.onlyCentralDepartments ) {
                        for ( let arr of this.subdivisions ) {
                            for ( let item of arr ) {
                                if ( item.hasOwnProperty( 'type' ) && item.type === 1 ) {
                                    this.centralSubdivisionId = item.id;
                                }
                            }
                        }
                    }
                }
            }
        },
        computed: {
            subdivisionLength() {
                return this.subdivisions.length;
            }
        },
        async created() {

            if ( this.initialValue && this.initialValue[0] )
                this.fetchByInitialValue( this.initialValue[0], typeof this.initialValue[1] === 'undefined' ? null : this.initialValue[1] );

            else if ( this.initialValue && !this.initialValue[0] && typeof this.initialValue[1] !== 'undefined' && this.initialValue[1] ) {
                try {
                    let response = await this.axios.get( this.$config.urls.hrm.fetchDepartment.url.replace( ':id', this.initialValue[1] ) );
                    this.fetchByInitialValue( response.data.data.stateId, response.data.data.id );
                }
                catch ( error ) {
                    await this.fetchStates();
                }
            }
            else
                await this.fetchStates();

        },
        mounted() {
            if ( !this.hideMainState ) {
                let searchInput = this.$refs.stateSelect.$el.getElementsByClassName( 'vs__search' ),
                    searchText = '';
                if ( searchInput.length > 0 ) searchInput[0].oninput = e => {
                    if ( this.timer ) clearTimeout( this.timer );
                    if ( searchText !== e.target.value ) {
                        this.timer = setTimeout( () => {
                            searchText = e.target.value;
                            this.searchState( searchText );
                            this.timer = null;
                        }, 500 );
                    }
                };
            }
        },
        methods: {
            fetchByInitialValue( stateId, departmentId ) {
                this.initializing = true;
                if ( stateId ) {
                    this.fetchStates().then( options => {
                        if ( options.map( option => option.id ).indexOf( stateId ) > -1 ) {
                            this.stateId = stateId;
                            this.initializing = false;
                        }
                        else {
                            this.fetchStateParents( stateId )
                                .then( async ( response ) => {
                                    let parents = response.data.data.map( state => state.id );
                                    let foundId = false;
                                    let i = 0;
                                    if ( parents.length === 0 ) this.initializing = false;
                                    if ( !this.isAdmin )
                                      for ( let stateIdInner of parents ) {
                                        if ( foundId || this.accessStates.indexOf( stateIdInner ) > -1 ) {
                                            foundId = true;
                                            if ( i === 0 ) {
                                                i++;
                                                continue;
                                            }
                                            if ( i === 1 ) {
                                                this.stateId = stateIdInner;
                                            }
                                            else {
                                                let response = await this.axios.get( this.$config.urls.hrm.fetchDivisions.url.replace( ':id', parents[i - 1] ) );
                                                this.subdivisions.push( response.data.data );
                                                this.subTree.push( stateIdInner );
                                                if ( i === parents.length - 1 ) {
                                                    this.$emit( 'input', stateIdInner );
                                                    if ( typeof this.lastStates !== 'undefined' && this.subdivisions.length > 0 ) {
                                                        if ( this.subdivisions[this.subdivisions.length - 1].filter( subdivision => subdivision.id === stateIdInner )[0].type === 1 ) this.$emit( 'update:lastStates', this.subdivisions[this.subdivisions.length - 1].filter( subdivision => subdivision.id !== stateIdInner ) );
                                                        else this.$emit( 'update:lastStates', [] );
                                                    }
                                                    let response1 = await this.axios.get( this.$config.urls.fetchStateDivisions.url.replace( ':id', stateIdInner ) );
                                                    if ( response1.data.data.length > 0 ) {
                                                        this.subdivisions.push( response1.data.data );
                                                        this.initializing = false;
                                                    }
                                                    else {
                                                        if ( !this.hideDepartment )
                                                            this.fetchDepartments( stateIdInner )
                                                                .then( () => {
                                                                    this.$emit( 'update:getDepartments', this.departments );
                                                                    this.departmentId = Number.parseInt( departmentId ) || '';
                                                                    this.lastState = true;
                                                                    this.initializing = false;
                                                                } );
                                                        else this.initializing = false;
                                                    }
                                                }
                                            }
                                        }
                                        i++;
                                    }
                                    else for ( let stateIdInner of parents ) {
                                        foundId = true;
                                        if ( i === 0 ) {
                                            if ( this.states.filter( state => state.id === stateIdInner ).length === 0 )
                                                this.states.push( ...response.data.data.filter( state => state.id === stateIdInner ).map( state => {
                                                    state.fullText = JSON.stringify( state );
                                                    return state;
                                                } ) );

                                            this.stateId = stateIdInner;
                                            if ( parents.length === 1 ) {
                                                this.initializing = false;
                                            }
                                        }
                                        else {
                                            let response = await this.axios.get( this.$config.urls.hrm.fetchDivisions.url.replace( ':id', parents[i - 1] ) );
                                            this.subdivisions.push( response.data.data );
                                            this.subTree.push( stateIdInner );
                                            if ( i === parents.length - 1 ) {
                                                this.$emit( 'input', stateIdInner );
                                                if ( typeof this.lastStates !== 'undefined' && this.subdivisions.length > 0 ) {

                                                    if ( this.subdivisions[this.subdivisions.length - 1].filter( subdivision => subdivision.id === stateIdInner )[0].type === 1 )

                                                        this.$emit( 'update:lastStates', this.subdivisions[this.subdivisions.length - 1].filter( subdivision => subdivision.id !== stateIdInner ) );

                                                    else
                                                        this.$emit( 'update:lastStates', [] );
                                                }
                                                let response1 = await this.axios.get( this.$config.urls.hrm.fetchDivisions.url.replace( ':id', stateIdInner ) );
                                                if ( response1.data.data.length > 0 ) {
                                                    this.subdivisions.push( response1.data.data );
                                                    this.initializing = false;
                                                }
                                                else {
                                                    if ( !this.hideDepartment )
                                                        this.fetchDepartments( stateIdInner )
                                                            .then( () => {
                                                                this.$emit( 'update:getDepartments', this.departments );
                                                                this.departmentId = Number.parseInt( departmentId ) || '';
                                                                this.lastState = true;
                                                                setTimeout( () => {
                                                                    this.initializing = false
                                                                }, 200 );
                                                            } );
                                                    else this.initializing = false;
                                                }
                                            }
                                        }
                                        i++;
                                    }
                                } )
                        }

                    } );
                }
            },
            fetchStateParents( stateId ) {
                return this.axios.get( this.$config.urls.hrm.fetchStateParents.url.replace( ':id', stateId ) );
            },
            fetchStates( id, index ) {
                this.$store.dispatch( 'setProgressbarInvisible' );
                if ( index === 1 && !id ) {
                    this.$emit( 'input', this.stateId );
                    this.lastState = false;
                    this.$store.dispatch( 'setProgressbarVisible' );
                    return new Promise( ( resolve, reject ) => {
                        resolve();
                    } );
                }
                else if ( index > 1 && !id ) {
                    this.$emit( 'input', this.subTree[index] );
                    this.lastState = false;
                    this.$store.dispatch( 'setProgressbarVisible' );
                    return new Promise( ( resolve, reject ) => {
                        resolve();
                    } );
                }
                else {
                    return this.axios.get( id ? this.$config.urls.hrm.fetchDivisions.url.replace( ':id', id ) : this.$config.urls.hrm.fetchStates.url ).then( response => {
                        if ( !id ) {
                            this.states = response.data.data.items.map( state => {
                                state.fullText = JSON.stringify( state );
                                return state;

                            } );
                            this.$store.dispatch( 'setProgressbarVisible' );
                            return response.data.data.items;
                        }
                        else if ( response.data.data.length > 0 ) {
                            if ( this.subdivisions[index] ) {
                                this.subdivisions[index] = response.data.data;
                                this.lastState = false;
                            }
                            else if ( !this.initializing ) {
                                this.subdivisions.push( response.data.data );
                            }
                            this.lastState = false;
                            this.$store.dispatch( 'setProgressbarVisible' );
                            return response.data.data;
                        }
                        else {
                            if ( typeof this.lastStates !== 'undefined' && this.subdivisions.length > 0 ) {
                                if ( this.subdivisions[index - 1].filter( subdivision => subdivision.id === id )[0].type === 1 )
                                  this.$emit( 'update:lastStates', this.subdivisions[index - 1].filter( subdivision => subdivision.id !== id ) );
                                else this.$emit( 'update:lastStates', [] );
                            }
                            if ( this.subdivisions[index] ) this.subdivisions = [...this.subdivisions].filter( ( sub, idx ) => idx < index );
                            if ( !this.hideDepartment ) {
                                this.lastState = false;
                                this.fetchDepartments( id )
                                    .then( () => {
                                        this.$emit( 'update:getDepartments', this.departments );
                                        this.$store.dispatch( 'setProgressbarVisible' );
                                        // If select is initializing
                                        if ( this.initializing && this.initialValue[1] ) {
                                            this.departmentId = this.initialValue[1];
                                            this.lastState = true;
                                        }
                                        else {
                                            this.lastState = true;
                                        }
                                    } );
                            }
                            else {
                                this.$store.dispatch( 'setProgressbarVisible' );
                            }
                            return [];
                        }
                    } )
                }
            },
            fetchDepartments( id ) {
                this.$store.dispatch( 'setProgressbarInvisible' );
                return this.axios.get( this.$config.urls.hrm.fetchDepartments.url.replace( ':id', id || this.value ) )
                           .then( response => {
                               this.departments = response.data.data;
                               this.$store.dispatch( 'setProgressbarVisible' );
                           } );
            },
            subTreeChange( subId, nextIndex ) {
                if ( !this.initializing ) {
                    this.$emit( 'update:lastStates', [] );
                    this.$emit( 'update:getDepartments', [] );
                    if ( subId ) this.fetchStates( subId, nextIndex ).then( () => {
                        this.subTree = this.subTree.slice( 0, nextIndex );
                        this.$emit( 'input', subId );
                        this.$emit( 'change', subId );
                        this.$emit( 'subdivision', subId );
                    } );
                    else {
                        this.subTree = this.subTree.slice( 0, nextIndex - 1 );
                        this.subdivisions = this.subdivisions.slice( 0, nextIndex );
                        let prevId = this.subTree.length > 0 ? this.subTree[this.subTree.length - 1] : this.stateId || null;
                        this.lastState = false;
                        this.$emit( 'input', prevId );
                        this.$emit( 'change', prevId );
                        this.$emit( 'subdivision', null );
                    }
                }
            },
            searchState( text ) {
                let params = {};
                if ( text ) params.query = text;
                return this.axios.get( this.$config.urls.hrm.fetchStates.url, {
                    params: params
                } ).then( response => {
                    this.states = response.data.data.items.map( state => {
                        state.fullText = JSON.stringify( state );
                        return state;
                    } );
                } );
            },
            // We will call this method from parent component for check validity
            checkValidity() {
                if ( !this.stateId ) {
                    this.valid.stateId = false;
                    return false;
                }
                if ( !this.firstRequired && this.subdivisions.length > 0 && !this.subTree[this.subdivisions.length - 1] ) {
                    this.valid.lastStateId = false;
                    return false;
                }
                if (( !this.hideDepartment && !this.onlyCentralDepartments) && !this.departmentId ) {
                    this.valid.departmentId = false;
                    return false;
                }
                return true;
            }
        }
    }
</script>

<style scoped>

</style>
